(function () {
  // several vib sections include this file; run once
  if (window.__vibContent) return;
  window.__vibContent = true;

  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const toBuy = () => ($('.vib .buy') || $('#vib-top') || document.body).scrollIntoView({ behavior: 'smooth', block: 'start' });
  const pick = n => { if (window.vibPickBundle && !isNaN(n)) window.vibPickBundle(n); };

  // reaction videos: arrows scroll one card; hidden at the ends / when everything fits
  function ugcState(track){
    const wrap = track.closest('.ugc-wrap'); if (!wrap) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    wrap.querySelector('.ugc-arrow.prev').disabled = track.scrollLeft <= 2;
    wrap.querySelector('.ugc-arrow.next').disabled = track.scrollLeft >= max;
  }
  const initUgc = () => $$('.vib .ugc-wrap .ugc').forEach(t => { ugcState(t); t.addEventListener('scroll', () => ugcState(t), { passive: true }); });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initUgc) : initUgc();
  window.addEventListener('resize', () => $$('.vib .ugc-wrap .ugc').forEach(ugcState));

  document.addEventListener('click', e => {
    const ua = e.target.closest('.vib .ugc-arrow');
    if (ua) {
      const t = ua.closest('.ugc-wrap').querySelector('.ugc'), card = t.firstElementChild;
      const stepW = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(t).columnGap || 16) : t.clientWidth;
      t.scrollBy({ left: ua.classList.contains('next') ? stepW : -stepW, behavior: 'smooth' });
      return;
    }
    // message ideas: mood buttons swap the example message
    const mood = e.target.closest('.vib-moods button');
    if (mood) {
      const wrap = mood.closest('.section');
      wrap.querySelectorAll('.vib-moods button').forEach(b => b.classList.toggle('on', b === mood));
      const q = wrap.querySelector('.vib-mood-text'), f = wrap.querySelector('.vib-mood-for');
      q.style.opacity = 0;
      setTimeout(() => { q.textContent = '“' + mood.dataset.msg + '”'; f.textContent = mood.dataset.for; q.style.opacity = 1; }, 180);
      return;
    }
    // multi-buy offer cards: select that bundle and go back to the buy box
    const mbc = e.target.closest('.vib .mbc');
    if (mbc) { pick(+mbc.dataset.pick); toBuy(); return; }
    // buttons that lead back to the buy box
    const tb = e.target.closest('.vib a.to-buy');
    if (tb && (!tb.getAttribute('href') || tb.getAttribute('href').startsWith('#'))) {
      e.preventDefault();
      if (tb.dataset.pick !== undefined) pick(+tb.dataset.pick);
      toBuy();
      return;
    }
    // reaction videos: tap to play with sound
    const card = e.target.closest('.vib .ugc .media-card');
    if (card) {
      const v = card.querySelector('video'); if (!v) return;
      v.muted = false;
      if (v.paused) {
        $$('.vib .ugc video').forEach(o => o !== v && o.pause());
        v.play(); const t = card.querySelector('.tag'); if (t) t.style.display = 'none';
      } else v.pause();
    }
  });
})();
